export const AUTHORIZE = '/oauth2/authorize';
export const AUTHORIZE_IDP = '/authorize/:idp';
export const CHANGE_EMAIL = '/changeEmail';
export const CHANGE_PASSWORD = '/changePassword';
export const PROFILE = '/profile';
export const COMPLETE_FORGOT_PASSWORD = '/complete-forgot-passowrd';
export const COMPLETE_MFA_SETUP = '/complete-mfa-setup';
export const CONFIRM_FORGOT_PASSWORD = '/confirmForgotPassword';
export const CONFIRM_SIGN_IN = '/confirm-sign-in';
export const CONFIRM_EMAIL_CHANGE = '/confirmEmailChange';
export const CONFIRM_EMAIL_CHANGE_V2 = '/confirmChangeEmail';
export const VERIFY_EMAIL_CHANGE = '/confirmNewEmail';
export const CONFIRM_REQUEST_EMAIL_CHANGE = '/requestEmailChange';
export const ERROR = '/error';
export const IDP_TOKEN = '/oauth2/idptoken';
export const FORGOT_PASSWORD = '/forgotPassword';
export const RESET_PASSWORD = '/resetPassword';
export const SETUP_MFA = '/setup-mfa';
export const SIGN_IN = '/login';
export const SIGN_OUT = '/logout';
export const SIGN_UP = '/signUp';
export const SIGN_UP_SELECTION = '/signUp/selection';
export const SIGN_UP_WITH_EMAIL = '/signUp/email';
export const SIGN_UP_COMPLETE_EMAIL = '/v2/signUp/completeEmail';
export const CONFIRM_SIGN_UP = '/v2/signUp/confirmSignUp';
export const USER_DETAILS = '/user-details';
export const USER_INFO = '/clientSession/userInfo';

export default {
    AUTHORIZE_IDP,
    AUTHORIZE,
    CHANGE_EMAIL,
    CHANGE_PASSWORD,
    COMPLETE_FORGOT_PASSWORD,
    COMPLETE_MFA_SETUP,
    CONFIRM_EMAIL_CHANGE,
    CONFIRM_EMAIL_CHANGE_V2,
    VERIFY_EMAIL_CHANGE,
    CONFIRM_REQUEST_EMAIL_CHANGE,
    CONFIRM_FORGOT_PASSWORD,
    CONFIRM_SIGN_IN,
    CONFIRM_SIGN_UP,
    ERROR,
    FORGOT_PASSWORD,
    IDP_TOKEN,
    PROFILE,
    RESET_PASSWORD,
    SETUP_MFA,
    SIGN_IN,
    SIGN_OUT,
    SIGN_UP,
    SIGN_UP_COMPLETE_EMAIL,
    SIGN_UP_WITH_EMAIL,
    SIGN_UP_SELECTION,
    USER_DETAILS,
    USER_INFO,
};
